import React from "react";
import Button from "../common/Button";
import "./heroSection.css";

const HeroSection = () => {
  return (
    
    <div className="hero-section-wrapper">
      <div className="flex absolute-center flex-col hero-section max-width">
        <br/><br/><br/><br/><br/><br/><br/><br/>
        <div className="hero-heading">
          AI-Driven Portfolio Management & Smart Investing
        </div>
        <div className="hero-subheading">
          Join thousands of investors using advanced machine learning, market insights, 
          and real-time analytics to grow and manage their wealth intelligently.
        </div>
        <Button buttonText="Get Early Access" />
      </div>
    </div>
  );
};

export default HeroSection;
